import { CircularProgress } from '@mui/material';
import type { CircularProgressProps } from '@mui/material';

export const INLINE_SPINNER_SIZE = 16;

export type InlineSpinnerProps = Omit<CircularProgressProps, 'size' | 'variant' | 'value'>;

export const InlineSpinner = (props: InlineSpinnerProps) => (
  <CircularProgress size={INLINE_SPINNER_SIZE} color="inherit" {...props} />
);
